import React from 'react';
import { Ship } from '../../interfaces/types';
import { ShipCard } from './ShipCard';
import { Pagination } from '../common/Pagination';
import { ViewModeButtons } from '../common/ViewModeButtons';
import './ShipList.css';

interface ShipListProps {
  ships: Ship[];
  pagination?: {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
  };
  onShipSelect: (ship: Ship) => void;
  viewType: 'grid' | 'list';
  username?: string;
  isAnonymous: boolean;
  showAddButton?: boolean;
  showRemoveButton?: boolean;
  showUsers?: boolean;
  isGrouped?: boolean;
  showCount?: boolean;
  onShipRemoved?: () => void;
  isCompareMode?: boolean;
  onCompareSelect?: (ship: Ship) => void;
  selectedForCompare?: string[];
  selectedType?: string;
  selectedSize?: string;
  isAdmin?: boolean;
  isUserFiltered?: boolean;
  // Props para los botones de visualización
  showViewModeButtons?: boolean;
  selectedUser?: string;
  setSelectedUser?: (user: string) => void;
  setIsGrouped?: (grouped: boolean) => void;
}

export const ShipList: React.FC<ShipListProps> = ({
  ships,
  pagination,
  onShipSelect,
  viewType,
  username,
  isAnonymous,
  showAddButton = true,
  showRemoveButton = false,
  showUsers = false,
  isGrouped = false,
  showCount = true,
  onShipRemoved,
  isCompareMode = false,
  onCompareSelect,
  selectedForCompare = [],
  selectedType = '',
  selectedSize = '',
  isAdmin = false,
  isUserFiltered = false,
  // Props para los botones de visualización
  showViewModeButtons = false,
  selectedUser = '',
  setSelectedUser,
  setIsGrouped,
}) => {
  return (
    <>
      <div className={`ship-list ${viewType}`}>
        {ships.map((ship, index) => (
          <ShipCard
            key={`${ship.id}-${ship.usuario || 'no-user'}`}
            ship={ship}
            onClick={onShipSelect}
            duplicateCount={ship.duplicateCount || 1}
            username={username}
            isAnonymous={isAnonymous}
            showAddButton={showAddButton}
            showRemoveButton={showRemoveButton}
            showUsers={showUsers}
            isGrouped={isGrouped}
            showCount={showCount}
            onShipRemoved={onShipRemoved}
            isCompareMode={isCompareMode}
            onCompareSelect={onCompareSelect}
            isSelectedForCompare={selectedForCompare.includes(ship.name)}
            selectedType={selectedType}
            selectedSize={selectedSize}
            isAdmin={isAdmin}
            isUserFiltered={isUserFiltered}
            isFirstInList={index === 0}
          />
        ))}
      </div>
      
      {/* Botones de visualización encima de la paginación */}
      {showViewModeButtons && username && setSelectedUser && setIsGrouped && (
        <ViewModeButtons
          isGrouped={isGrouped}
          setIsGrouped={setIsGrouped}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          username={username}
        />
      )}
      
      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={pagination.onPageChange}
        />
      )}
    </>
  );
}; 